import * as THREE from "three";
import {
  HiOutlineBookOpen,
  HiOutlineDesktopComputer,
  HiOutlineEmojiHappy,
  HiOutlineHome,
  HiOutlineOfficeBuilding,
} from "react-icons/hi";
import { SECTIONS } from "./sections";

const iconSize = "25px";

export const home = {
  name: SECTIONS.HOME,
  camera: {
    desktop: {
      position: { x: 8.0, y: 5.0, z: -8.0 },
      target: { x: 0, y: 1.5, z: 0 },
    },
    tablet: {
      position: { x: 8.0, y: 5.0, z: -8.0 },
      target: { x: 0, y: 1.5, z: 0 },
    },
    mobile: {
      position: { x: 17, y: 5, z: -17 },
      target: { x: 0, y: 1.5, z: 0 },
    },
  },
  icon: <HiOutlineHome size={iconSize} />,
};

export const points = [
  //TODO: Uncomment this when the section has something to show
  // {
  //   name: SECTIONS.DESK,
  //   camera: {
  //     desktop: {
  //       position: { x: -2.0, y: 1.5, z: -3.0 },
  //       target: { x: -2, y: 1.5, z: 2.2 },
  //     },
  //     tablet: {
  //       position: { x: -2.0, y: 1.5, z: -3.0 },
  //       target: { x: -2, y: 1.5, z: 2.2 },
  //     },
  //     mobile: {
  //       position: { x: -2.1, y: 1.5, z: -4.0 },
  //       target: { x: -2.1, y: 1.5, z: 2.2 },
  //     },
  //   },
  //   position: new THREE.Vector3(-1.5, 1.6, 2),
  //   icon: <HiOutlineDesktopComputer size={iconSize} />,
  // },
  {
    name: SECTIONS.LIBRARY,
    camera: {
      desktop: {
        position: { x: 1.5, y: 1.7, z: -2.4 },
        target: { x: -2.4, y: 1.7, z: -2.4 },
      },
      tablet: {
        position: { x: 1.5, y: 1.7, z: -2.4 },
        target: { x: -2.4, y: 1.7, z: -2.4 },
      },
      mobile: {
        position: { x: 1.0, y: 1.5, z: -2.38 },
        target: { x: -2.4, y: 1.5, z: -2.38 },
      },
    },
    position: new THREE.Vector3(-2.5, 1.5, -2.3),
    icon: <HiOutlineBookOpen size={iconSize} />,
  },
  {
    name: SECTIONS.HOBBIES,
    camera: {
      desktop: {
        position: { x: 1.3, y: 1.2, z: -2 },
        target: { x: 1.3, y: 1.2, z: 2.1 },
      },
      tablet: {
        position: { x: 1.3, y: 1.2, z: -2 },
        target: { x: 1.3, y: 1.2, z: 2.1 },
      },
      mobile: {
        position: { x: 1.3, y: 2.0, z: -7 },
        target: { x: 1.3, y: 1.5, z: 3.0 },
      },
    },
    position: new THREE.Vector3(1.2, 1.5, 2),
    icon: <HiOutlineEmojiHappy size={iconSize} />,
  },
  {
    name: SECTIONS.EXPERIENCE,
    camera: {
      desktop: {
        position: { x: 0.5, y: 3.6, z: 0.1 },
        target: { x: -3.03, y: 3.6, z: 0.1 },
      },
      tablet: {
        position: { x: 0.5, y: 3.6, z: 0.1 },
        target: { x: -3.03, y: 3.6, z: 0.1 },
      },
      mobile: {
        position: { x: 5.0, y: 2.0, z: 0.1 },
        target: { x: -3.03, y: 3.5, z: 0.1 },
      },
    },
    position: new THREE.Vector3(-3, 3.6, 0),
    icon: <HiOutlineOfficeBuilding size={iconSize} />,
  },
];
